import LineTabs from './LineTabs';
import './LineTabs.scss';

export default LineTabs;